"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = insertTemplateIntoDocument;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));
/**
 *
 *
 * @param {String} pixelName Used for debugging / logging purposes
 * @param {Node} htmlElementToInsert The node we want to insert into the body of the document
 * @returns {Node} The actual HTML DOM Node that was ultimately inserted into the body of the document
 */


function insertElementIntoBodyAndMaybeExecuteScript(pixelName, htmlElementToInsert) {
  try {
    var weAreInsertingScript = String(htmlElementToInsert.nodeName).toUpperCase() === 'SCRIPT';
    var isScriptTypeJavascript = !htmlElementToInsert.type || htmlElementToInsert.type === 'text/javascript'; // If this is an inline script, just setting innerHTML and appending it to the DOM won't work
    // We need to do this create-a-script-element-and-set-the-text method, which is copied from Google Tag Manager's source code
    // It's also necessary for remote scripts, where the src property points to a remote script

    if (weAreInsertingScript && isScriptTypeJavascript) {
      var newScriptElementToInsert = document.createElement('script');
      newScriptElementToInsert.async = false;
      newScriptElementToInsert.type = 'text/javascript';
      newScriptElementToInsert.id = htmlElementToInsert.id;
      var originalScriptSrc = htmlElementToInsert.src;

      if (originalScriptSrc) {
        newScriptElementToInsert.src = originalScriptSrc;
      }

      if (htmlElementToInsert.charset) {
        newScriptElementToInsert.charset = htmlElementToInsert.charset;
      }

      var originalScriptContents = htmlElementToInsert.text || htmlElementToInsert.textContent || htmlElementToInsert.innerHTML || '';

      if (originalScriptContents) {
        newScriptElementToInsert.text = originalScriptContents;
      }

      htmlElementToInsert = newScriptElementToInsert;
    } // Using FB pixels styling to make pixel invisible but fireable


    htmlElementToInsert.style.display = 'none';
    htmlElementToInsert.height = '1';
    htmlElementToInsert.width = '1';
    document.body.insertBefore(htmlElementToInsert, null);
    return htmlElementToInsert;
  } catch (e) {
    console.error("[pixels plugin]:: error while loading htmlTemplate pixel ".concat(pixelName), e);
    return null;
  }
}
/**
 *
 *
 * @param {String} pixelName The name of the pixel responsible for inserting this template. Used for debugging and logging purposes.
 * @param {String} renderedTemplate A string describing the rendered HTML template / tree to inject into the body of the document.
 * @returns {Node[]} The array of nodes that have been inserted into the document
 */


function insertTemplateIntoDocumentForreal(pixelName, renderedTemplate) {
  var div = document.createElement('div');
  div.innerHTML = renderedTemplate;
  var allTemplateChildElements = Array.from(div.children); // TODO make all remote scripts asynchronous
  // TODO sandbox?

  var insertedChildElements = allTemplateChildElements.map(function (childElement) {
    return insertElementIntoBodyAndMaybeExecuteScript(pixelName, childElement);
  }); // `insertedChildElements` is now the array of DOM Nodes that have been inserted into the body

  return insertedChildElements;
}
/**
 * This function, after waiting a tick (in order to protect the caller's tick from errors that may occur),
 * injects the HTML tree represented in `renderedTemplate` into the DOM.
 *
 * (It returns a Promise rather than the array itself because it does the actual insertion after this tick, so it's necessarily asynchronous)
 * @export
 * @param {String} pixelName The name of the pixel responsible for inserting this template. Used for debugging and logging purposes.
 * @param {String} renderedTemplate A string describing the rendered HTML template / tree to inject into the body of the document.
 * @returns {Promise<Node[]>} A Promise that resolves with an array containing the nodes that have been inserted into the document
 */


function insertTemplateIntoDocument(_x, _x2) {
  return _insertTemplateIntoDocument.apply(this, arguments);
}

function _insertTemplateIntoDocument() {
  _insertTemplateIntoDocument = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(pixelName, renderedTemplate) {
    var nextTickPromise, insertedChildElements;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // We use setTimeout so that there's really no way for this HTML manipulation to break our player or app tick
            // Note that this means in tests you might have to await the next tick to check for the DOM side effects
            nextTickPromise = new Promise(function (resolve) {
              setTimeout(resolve, 0);
            });
            _context.next = 3;
            return nextTickPromise;

          case 3:
            insertedChildElements = insertTemplateIntoDocumentForreal(pixelName, renderedTemplate);
            return _context.abrupt("return", insertedChildElements);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _insertTemplateIntoDocument.apply(this, arguments);
}